/**
 * ## javascript Tabs module Usage
 *
 * ### Markup:
 * <div class="tabs">
 *   <ul class="tabs__tablist" role="tablist">
 *       <li role="presentation"><a id="tab1" role="tab" href="#tab-title1" aria-selected="true">Tab Title 1</a></li>
 *       <li role="presentation"><a id="tab2" role="tab" href="#tab-title2">Tab Title 2</a></li>
 *   </ul>
 *   <section id="tab-title1" class="tabs__panel rtecontent" role="tabpanel" tabindex="-1" role="tabpanel" aria-labelledby="tab1">
 *       Tab Content Goes Here
 *   </section>
 *   <section id="tab-title2" class="tabs__panel rtecontent" role="tabpanel" tabindex="-1" role="tabpanel" aria-labelledby="tab2">
 *       Tab Content Goes Here
 *   </section>
 * </div>
 * 
 **/
export default (($) => {

    return function() {

        const tabsContainer = document.querySelector(".tabs");
        const tabsList = tabsContainer.querySelector("ul");
        const tabButtons = tabsList.querySelectorAll("button");
        const tabPanels = tabsContainer.querySelectorAll(".tabs__panels > section");

        tabButtons.forEach((tab, index) => {

            if (index === 0) {
                tab.setAttribute("aria-selected", "true");
                // we'll add something here
            } else {
                tab.setAttribute("tabindex", "-1");
                tabPanels[index].setAttribute("hidden", "");
            }
        });

        tabPanels.forEach((panel) => {
            panel.setAttribute("tabindex", "0");
        });

        tabsList.addEventListener("click", (e) => {
            const clickedTab = e.target.closest("button");
            if (!clickedTab) return;
            e.preventDefault();

            switchTab(clickedTab);
        });

        tabsContainer.addEventListener("keydown", (e) => {
            switch (e.key) {
                case "ArrowLeft":
                    moveLeft();
                break;
                case "ArrowRight":
                    moveRight();
                break;
                case "Home":
                    e.preventDefault();
                    switchTab(tabButtons[0]);
                break;
                case "End":
                    e.preventDefault();
                    switchTab(tabButtons[tabButtons.length - 1]);
                break;
            }
        });

        function moveLeft() {
            const currentTab = document.activeElement;
            if (!currentTab.parentElement.previousElementSibling) {
                switchTab(tabButtons[tabButtons.length - 1]);
            } else {
                switchTab(
                currentTab.parentElement.previousElementSibling.querySelector("button")
                );
            }
        }

        function moveRight() {
            const currentTab = document.activeElement;
            if (!currentTab.parentElement.nextElementSibling) {
                switchTab(tabButtons[0]);
            } else {
                switchTab(currentTab.parentElement.nextElementSibling.querySelector("button"));
            }
        }

        function switchTab(newTab) {
            const activePanelId = newTab.getAttribute("aria-controls");
            const activePanel = tabsContainer.querySelector('#' + activePanelId);

            console.log(activePanel);

            tabButtons.forEach((button) => {
                button.setAttribute("aria-selected", false);
                button.setAttribute("tabindex", "-1");
            });

            tabPanels.forEach((panel) => {
                panel.setAttribute("hidden", true);
            });

            activePanel.removeAttribute("hidden", false);

            newTab.setAttribute("aria-selected", true);
            newTab.setAttribute("tabindex", "0");
            newTab.focus();
        }
        

    }

})(jQuery)
